<template>
  <v-app>
      <HeaderNav />
      <v-main class="mt-4">
          <router-view  v-if="$route.path === '/'"/>
        <v-container v-else>
          <router-view/>
        </v-container>
      </v-main>
      <NewsLetter />
      <FooterNav />
  </v-app>
</template>

<script>
import HeaderNav from './components/HeaderNav'
import FooterNav from './components/FooterNav'
import NewsLetter from './components/NewsLetter'

export default {
  name: 'App',

  components: {
    HeaderNav,
    FooterNav,
    NewsLetter
  },

  computed:{
    routePath(){
       return this.$route.path 
    },
  }
};
</script>
